import store from '@/store'

export default [
  {
    path: '/corporate-partners',
    name: 'corporate-partner',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate-partner/form.vue')
  },
  {
    path: '/corporate-partners/:id',
    name: 'corporate-partner-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate-partner/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('corporatePartner/find', to.params.id)
      next()
    }
  }
]
